export default __webpack_public_path__ + "static/media/speed_V2.5466234a.svg";